var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"hm-search-input",attrs:{"type":"search","placeholder":"Search"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }